"use strict";
import { useIsDarkMode } from "theme/components/ThemeToggle";
import {
  ARBITRUM_LOGO,
  AVALANCHE_LOGO,
  BASE_LOGO,
  BLAST_LOGO,
  BNB_LOGO,
  CELO_LOGO,
  ETHEREUM_LOGO,
  H2_LOGO,
  MONAD_LOGO,
  OPTIMISM_LOGO,
  POLYGON_LOGO,
  UNICHAIN_SEPOLIA_LOGO,
  WORLD_CHAIN_LOGO,
  ZKSYNC_LOGO,
  ZORA_LOGO
} from "ui/src/assets";
import { getChainInfo } from "uniswap/src/features/chains/chainInfo";
import { useIsSupportedChainId } from "uniswap/src/features/chains/hooks/useSupportedChainId";
export function getChainUI(chainId, darkMode) {
  const chainIdValue = Number(chainId);
  if (chainIdValue === 2582) {
    return {
      symbol: H2_LOGO,
      bgColor: "#4A90E233",
      textColor: "#4A90E2"
    };
  }
  if (chainIdValue === 1 || chainIdValue === 11155111) {
    return {
      symbol: ETHEREUM_LOGO,
      bgColor: "#6B8AFF33",
      textColor: "#6B8AFF"
    };
  }
  if (chainIdValue === 137) {
    return {
      symbol: POLYGON_LOGO,
      bgColor: "#9558FF33",
      textColor: "#9558FF"
    };
  }
  if (chainIdValue === 42161) {
    return {
      symbol: ARBITRUM_LOGO,
      bgColor: "#00A3FF33",
      textColor: "#00A3FF"
    };
  }
  if (chainIdValue === 10) {
    return {
      symbol: OPTIMISM_LOGO,
      bgColor: "#FF042033",
      textColor: "#FF0420"
    };
  }
  if (chainIdValue === 42220) {
    return darkMode ? {
      symbol: CELO_LOGO,
      bgColor: "#FCFF5233",
      textColor: "#FCFF52"
    } : {
      symbol: CELO_LOGO,
      bgColor: "#FCFF5299",
      textColor: "#655947"
    };
  }
  if (chainIdValue === 43114) {
    return {
      symbol: AVALANCHE_LOGO,
      bgColor: "#E8414233",
      textColor: "#E84142"
    };
  }
  if (chainIdValue === 56) {
    return {
      symbol: BNB_LOGO,
      bgColor: "#EAB20033",
      textColor: "#EAB200"
    };
  }
  if (chainIdValue === 8453) {
    return {
      symbol: BASE_LOGO,
      bgColor: "#0052FF33",
      textColor: "#0052FF"
    };
  }
  if (chainIdValue === 81457) {
    return darkMode ? {
      symbol: BLAST_LOGO,
      bgColor: "rgba(252, 252, 3, 0.12)",
      textColor: "rgba(252, 252, 3, 1) "
    } : {
      symbol: BLAST_LOGO,
      bgColor: "rgba(252, 252, 3, 0.16)",
      textColor: "rgba(17, 20, 12, 1)"
    };
  }
  if (chainIdValue === 7777777) {
    return darkMode ? {
      symbol: ZORA_LOGO,
      bgColor: "rgba(255, 255, 255, 0.12)",
      textColor: "#FFFFFF"
    } : {
      symbol: ZORA_LOGO,
      bgColor: "rgba(0, 0, 0, 0.12)",
      textColor: "#000000"
    };
  }
  if (chainIdValue === 324) {
    return darkMode ? {
      symbol: ZKSYNC_LOGO,
      bgColor: "rgba(97, 137, 255, 0.12)",
      textColor: "#6189FF"
    } : {
      symbol: ZKSYNC_LOGO,
      bgColor: "rgba(54, 103, 246, 0.12)",
      textColor: "#3667F6"
    };
  }
  if (chainIdValue === 480) {
    return darkMode ? {
      symbol: WORLD_CHAIN_LOGO,
      bgColor: "rgba(255, 255, 255, 0.12)",
      textColor: "#FFFFFF"
    } : {
      symbol: WORLD_CHAIN_LOGO,
      bgColor: "rgba(0, 0, 0, 0.12)",
      textColor: "#000000"
    };
  }
  if (chainIdValue === 1301) {
    return {
      symbol: UNICHAIN_SEPOLIA_LOGO,
      bgColor: "#fc0fa4",
      textColor: "#fc0fa4"
    };
  }
  if (chainIdValue === 41144114) {
    return {
      symbol: MONAD_LOGO,
      bgColor: "#200052",
      textColor: "#836EF9"
    };
  }
  return void 0;
}
const getDefaultBorderRadius = (size) => size / 2 - 4;
export function ChainLogo({
  chainId,
  style,
  size = 12,
  borderRadius = getDefaultBorderRadius(size),
  testId,
  fillContainer = false
}) {
  const darkMode = useIsDarkMode();
  const isSupportedChain = useIsSupportedChainId(chainId);
  if (!isSupportedChain) {
    return null;
  }
  const { label } = getChainInfo(chainId);
  const { symbol } = getChainUI(chainId, darkMode);
  const iconSize = fillContainer ? "100%" : size + "px";
  return symbol ? <img
    aria-labelledby="titleID"
    data-testid={testId}
    width={iconSize}
    height={iconSize}
    src={symbol}
    style={{ ...style, borderRadius: borderRadius + "px" }}
    alt={`${label} logo`}
  /> : null;
}
